import { style } from 'typestyle';
import { faintBorderColor, TEAL_PRIMARY } from 'src/utils/Style/Theme';
import { asyncCellStateNest } from 'src/components/ConfigurableGrid/ConfigurableGrid.styles';

export default {
  outerContainer: style({
    $debugName: 'outerContainer',
    width: '100%',
    height: '100%',
    lineHeight: '35px',
  }),
  container: style({
    $debugName: 'container',
    display: 'flex',
    position: 'relative',
    marginBottom: 20,
    $nest: {
      ...asyncCellStateNest,
    }
  }),
  titleColumn: style({
    $debugName: 'titleColumn',
    width: '20%',
    paddingLeft: '0.5rem',
  }),
  dataColumnWrapper: style({
    $debugName: 'dataColumnWrapper',
    width: '80%',
    display: 'flex',
    flexWrap: 'wrap',
    paddingTop: '1rem',
  }),
  dataColumn: style({
    $debugName: 'dataColumn',
    display: 'flex',
    justifyContent: 'center',
    fontSize: '0.9rem',
    width: 410,
  }),
  textColumn: style({
    $debugName: 'textColumn',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    marginRight: '1rem',
    width: '50%',
  }),
  valueColumn: style({
    $debugName: 'valueColumn',
    display: 'flex',
    flexDirection: 'column',
    width: '50%',
    marginTop: -8,
  }),
  dataItem: style({
    $debugName: 'dataItem',
    height: '48px',
    marginBottom: 8,
  }),
  dataText: style({
    $debugName: 'dataText',
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    width: '100%',
  }),
  dropdownValue: style({
    $debugName: 'dropdownValue',
    display: 'flex',
    overflowY: 'auto',
  }),
  dataTextAmongEditors: style({
    $debugName: 'dataTextAmongEditors',
    display: 'flex',
    alignItems: 'flex-end',
  }),
  dataTextInput: style({
    $debugName: 'dataTextInput',
    padding: 0,
    margin: '0px !important',
    position: 'relative',
    top: -2,
  }),
  divider: style({
    $debugName: 'divider',
    borderBottom: `1px solid ${faintBorderColor}`,
    width: '100%',
    bottom: -10,
    position: 'absolute',
  }),
  editableValue: style({
    $debugName: 'editableValue',
    color: TEAL_PRIMARY,
    cursor: 'pointer',
  }),
  fakeDropdown: style({
    $debugName: 'fakeDropdown',
    border: '1px solid rgba(0, 0, 0, 0.23)',
    borderRadius: 4,
    padding: '6px 12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    minHeight: 40,
    background: '#fff',
    cursor: 'pointer',
    width: '100%',
    maxWidth: '400px',
    minWidth: '200px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    $nest: {
      '&:hover': {
        borderColor: 'rgba(0, 0, 0, 0.87)',
      },
      '&[aria-disabled="true"], &[disabled]': {
        backgroundColor: '#f5f5f5',
        cursor: 'default',
        pointerEvents: 'none',
      },
    },
  }),
  fakePlaceholder: style({
    $debugName: 'fakePlaceholder',
    color: 'rgba(0, 0, 0, 0.54)',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  }),
  fakeIcon: style({
    $debugName: 'fakeIcon',
    fontSize: '32px !important',
    color: 'rgba(0, 0, 0, 0.54)',
    borderLeft: '1px solid rgba(0, 0, 0, 0.23)',
    paddingLeft: 12,
    marginLeft: 12,
  }),
};
